export const PRODUCT_VIDEOS = {
  517: 'RR1J0MCSf7M',
  1883: 'ocSnrPEc5Mo',
  519: 'zD2yIN3k9D0',
  508: 'xPdDHU5Jtkw',
  507: 'qdrcG59dvo8',
  4648: 'QYSMVanEEGQ',
  2524: 'o9JBQv-PJ1I',
  730: 'CLZIKJ7Uz_U',
  516: 'pWG5Mexek6A',
  2548: '0UyOSyJ4UA4',
  1701: 'vhOq1Zm5O_Y',
  1420: 'lizuNvIrbBA',
  2370: '0mI1ByoJXfA',
  734: 'JhV57Kpz2as',
  3037: 'nrpLayS57cY',
  2832: 'B2jmDT64nJ0',
  3023: '3FwkGDEOTwM',
  3008: 'nEtHYzsTXUI',
  3027: 'JE_Fzt6uT2g',
  5081: 'Vi64h3_410k',
  2843: 'udAfi1GnSaw',
  5331: 'wG7BwkHzB6s',
  3026: 'D32x3Y6_Sbw',
  3034: 'mKa-pi577n0',
  5091: 'QSDwj5cC4xU',
  7785: '80n2c7mVTjs',
  4534: 'VzEqG-qyMMY',
  4653: 'B4-detm8AmA',
  5888: 'ob2ztdZbwtU',
  5831: 'zJgwkABvzHY',
  4654: 'KLlUJBldR2k',
  4552: '6A8h3VzmtY8',
  5947: 'OuCaOViStU8',
  1293: 'iXZ33Dg9uZw',
  7703: '2VqtFGGxnck',
  4531: 'mQD2F9W5bN0',
  7185: 'ebhgabbheO0',
  5838: 'CCluT0n0wcE',
  5820: 'EhDY9LBeeiM',
  512: 'vLt9wo1PbTo',
  7892: 'wp_Dqsc4I48',
  7893: 'NQDmbIh_OVY',
  7894: 'NQDmbIh_OVY',
  7895: 'NQDmbIh_OVY',
  7896: 'NQDmbIh_OVY',
  7963: 'qUoycFLyXio',
  7964: 'zN0D8lsp_R0',
  7962: 'A2U2Ri6lQsU',
  7905: '8RZ6A2ja6zo',
  7906: 'bXAXkcTHGmE',
  7907: 'mFo1WKl1d5E',
  7908: 'LLqtnGC7KGw',
  7909: 'aJJAzaoRbZA',
  7913: 'ANuayDyMz70',
  5264: 'nZdKzm5gxZA',
  7911: 'IeEVcbEo88E',
  3909: '_49B5_I098A',
  7442: 'jwix_fV44W8',
  2545: '1yYh1h5Jfsw',
  7366: 'NPGPJQD4IIc',
  7443: '9Ki01fgeYMI',
  6732: 'cnOUSiH4lJA',
  7324: 't0l9jE336BU',
  6170: '4toOAsglNBQ',
  3161: 'cnOUSiH4lJA',
  5217: '_49B5_I098A',
  3895: '_49B5_I098A',
  7603: 't0l9jE336BU',
  1868: '1yYh1h5Jfsw',
  7354: '9Ki01fgeYMI',
  6172: '4toOAsglNBQ',
  6173: '4toOAsglNBQ',
  3137: 'cnOUSiH4lJA',
  7654: '4toOAsglNBQ',
  7830: '_49B5_I098A',
  7653: '4toOAsglNBQ',
  3241: 'cnOUSiH4lJA',
  7649: '_49B5_I098A',
  7655: '4toOAsglNBQ',
  6616: '_49B5_I098A',
  7569: 'jwix_fV44W8',
  7581: 't0l9jE336BU',
  7648: '_49B5_I098A',
  3816: 't0l9jE336BU',
  3391: 'LyV9l1L2o9c',
  924: 'x6c1d3ZoVMY',
  925: 'x6c1d3ZoVMY',
  926: 'x6c1d3ZoVMY',
  1866: 'B_vtqkaI0k0',
  1878: 'eCVSa0y_KFA',
  1875: 'UMvG9OglK6w',
  6111: 'G-xVN9aOjWI',
  1870: '-rIbc-iEFy0',
  7353: 'EbcyGHrfF4Y',
  3057: 'CcN4YJODv8o',
  1879: 'eCVSa0y_KFA',
  6235: 'EMcWpmDqdl8',
  5055: '1Ku1lmMu_Ow',
  5061: '1Ku1lmMu_Ow',
  6099: 'G-xVN9aOjWI',
  7537: 'P1mXsf4YiBM',
  7875: 'Cpe1NYN9dNA',
  1896: 'Y7kKokw-IVM',
  2565: 'C0Cgt-y7L-A',
  2903: 'SiDcnDdsIbM',
  4238: 't4dFDjBGYqo',
  7674: '2sys1XQauCY',
  1894: '1Ku1lmMu_Ow',
  7570: '2sys1XQauCY',
  4217: 'B_vtqkaI0k0',
  7436: 'dZQqxxgo9-Q',
  6117: 'SiDcnDdsIbM',
  6762: 'x5JhlX4Im5w',
  1874: 'pkg3gfW2Fcw',
  2472: 'Y7kKokw-IVM',
  4233: 'Ene42RgF1vc',
  4235: 'hjt1iXqlp9w',
  4292: 'G-xVN9aOjWI',
  7360: 'dZQqxxgo9-Q',
  2819: 'TEgs0V-wNf8',
  3448: '1Ku1lmMu_Ow',
  7365: 'jmhKqOW6ubw',
  1880: 'JzMuK1RfHoc',
  4234: 'jiwk2WttSkU',
  2539: '-rIbc-iEFy0',
  2998: 'hGYU4QZ2XpU',
  7370: '2Icf89_mH_4',
  3022: 'C0Cgt-y7L-A',
  7632: '_ebgXsug2jE',
  2830: '_An9iznq2Ic',
  7358: '2sys1XQauCY',
  1867: 'Xq79t7fOew0',
  6114: 'SiDcnDdsIbM',
  7444: 'Pcs5dnvxBfg',
  5073: 'Y7kKokw-IVM',
  4445: 'P1mXsf4YiBM',
  2505: 'uXQeMVguB1c',
  8565: 'MkM216kPYiA',
  8566: '7TW61xN49Hs',
  8571: '-SuY4ggh8Fc',
  7925: 'DOtxxpCa5Qo',
  7927: 'He16-3R8MFk',
  7563: 'Cf_hITyr6Ys',
  7148: 'ywrulaQh-R8',
  6402: '8EiSXVC84Vk',
  7509: 'wwM64NoTl54',
  5730: 'U90ur9bLcPs',
  3075: 'ywrulaQh-R8',
  846: 'yPJ5MK1K6X4',
  2700: 'B_vtqkaI0k0',
  1864: 'C0Cgt-y7L-A',
  3325: '1vsnsf4eMNY',
  7359: 'ZkDm2mYFck0',
  2400: 'q9Rk3Q7QBaY',
  3324: 'HIprdTqXzeo',
  4444: 'NKbcBfoSNWw',
  7650: 'hwcbWXNCOWw',
  7375: 'u1HjZoQFG4g',
  7367: 'psd80LOimOE',
  7357: 'v29xzipXkmA',
  4788: '8EiSXVC84Vk',
  4588: 'kzb0X7P6tYc',
  3436: 'IwRLAEZ0biw',
  7504: 'wwM64NoTl54',
  4643: '7D_bLHyyrO4',
  4638: 'XU0mbELEK5k',
  4239: 'VFIVpnuBp7Q',
  3367: '-q4EoW-HvzA',
  3366: 'HIprdTqXzeo',
  549: 'o99B3NYo3Sg',
  7658: 'qDZ5TL0BlmE',
  7434: 'v29xzipXkmA',
  7394: 'XvuoKd9XokY',
  3599: 'p6XG50mxZrI',
  3362: 'HIprdTqXzeo',
  2872: 'vtGFvoN_pU8',
  2385: '2G1skPYgkTk',
  5642: '8EiSXVC84Vk',
  4952: '5IcUHsu67U8',
  5240: 'lf_AuFFJOzo',
  8737: 'XFK1MfpdxMM',
  8738: 'wS4QUxicgmw',
  8764: 'OnfnooZCRQI',
  8800: 'GULmQcGJNEg',
  1877: 'eH5P-T2rILo',
  7814: 'eH5P-T2rILo',
  8585: 'aRHUBy3iGIM',
  8741: 'UoqxYNyB7RA',
  8766: '2WWmypIJFOQ',
  8784: 'Odi5440oxvQ',
  8780: 'qsF2-4oHW1s',
  8781: '9_GenMiumxw',
  1739: 'eRChS7DvlDI',
  3989: 'irkt5xk2E7E',
  9037: 'zE8EkwI2aKQ',
  1892: 'EYo3tn9FRDA',
  10176: 'myZWcQRLjrw',
  10177: 'KRiaCH1AjBE',
  10180: 'F_vwPnyJC6o',
  10181: 'WNd3Q-PIJ94',
  10182: 'tH7r1E8V6D4',
  10190: '7zja7xUOFA4',
  10191: '-_hOBhlwAg8',
  10202: 'dmFJiHJYLHk',
  10350: 'XmI_OQCrwWY',
  10351: 'VROj_LL1Ivo',
  9718: 'uXQeMVguB1c',
  9716: 'uXQeMVguB1c',
  9717: 'uXQeMVguB1c',
  11178: '9pz1qXLtBzg',
  8583: 'L9HU3Ji-xB4',
  10539: 'j5iP8hrGIH4',
  10546: 'ucFP4WlqjF0',
  10549: 'kQSRvp1RIJA',
};
